import React from 'react'
import {InfoSection} from '../../Components'
import {  HomeObj2 ,HomeObj3} from './Data'
function Products(){
    return (
        <>
       
     
      <InfoSection {...HomeObj2}/> `` 
      <InfoSection {...HomeObj3}/>    
        </>
    )
}

export default Products